import moment from 'moment'
import {CarbonDate, Group, OptionProps} from '../group/groupModels'
import { AccountLicensePackage } from '../license/licenseModel'
import { AssociativeArray } from '../content/contentModels'
import { AuthModel } from '../../../modules/auth'

export interface InitialState {
    currDevice: Device,
    mqttDevice: any,
    errStatus: boolean,
    arrMQTTResponses : any,    
    currDeviceMqttClient : any | null,
    lastDeviceStatus: any[]
}

export interface Address{
    address: string,
    suburb: string,
    city: string,
    state?: string,
    country?: string
}

// export interface DeviceParams{

// }

// export interface Device{
//     id: string
//     deviceID: string,
//     deviceUnique: string,
//     PIN?: string,
//     deviceName: string,    
//     model: string,            
//     status: string,            
//     cyb_service_online: boolean,
//     type: string,        
//     lastUpdated : string,
//     avgWeekUsage : number,

//     address?: Address,
//     expiration?: {
//         isExpired: boolean,
//         expiredDate: string
//     },
//     groupId?: string,
//     params?: DeviceParams
//     // userId?: string
// }


// export interface MQTTDeviceResponses{
//     device: string,
//     arrResponses: MQTTResponse[],    
// }

// export interface MQTTResponse{
//     topic: string,
//     message: string
// }

export interface WorkerMessageEvents{
    devices: Device[],
    action: string,
    auth:  any,
}

export interface Other{
    deviceId: string,
    licensePackageId: string,
    pin: string
}

export interface iDeviceNotification{
    offline: iDeviceOfflineNotification,
    report: iDeviceReportNotification
}

export interface iDeviceReportNotification{
    deviceId: string,
    proofOfPlay: boolean | number,
    deviceNetwork: boolean | number,
    deviceStatus?: boolean | number,
    email: null | string,
    lastEmailSent: null | CarbonDate
}
export interface iDeviceOfflineNotification{
    deviceId: string,
    isEnable: boolean | number,
    email: null | string, /* If null, will pick up account email address */
    lastEmailSent: null | CarbonDate
}

export interface iDeviceAudit{
    deviceId: string,
    auditTypes: [],
}

export interface DeviceSettings{
    rotation: string,
    device_time_zone?: string,
    show_time?: boolean | number,
    location: string,
    volume?: number
}

export interface Device{
    id          : string,
    deviceName  : string,
    // rotation    : string,
    groupId     : string,
    isHostSite  : boolean,
    groupName?   : string,
    groupDisplayType?: string,
    category?    : string,
    groupUpdatedAt?: CarbonDate | null,
    groupCreatedAt?: CarbonDate | null,
    groupOverlappingMode?: number,
    show_time?    : boolean,    //display digital clock on top-right of the screen

    app_ver?     : string,
    checkin_time?: string,
    created_at?  : CarbonDate | null,
    updated_at?  : CarbonDate | null,
    auto_signin? : number,
    device_manufacturer?: string,
    device_model?: string,     
    device_time_zone?: string,
    external_storages?: string,
    deviceUnique?: string,    
    has_camera?  : boolean,
    has_touch?   : boolean,    
    note?        : string,
    settings?    : string,
    pin?         : string,
    platform?    : string,
    platform_ver?: string,    
    status_id?   : number,
    type?        : string,   
    userId?      : string,  
    account_license_package_id?: string,
    status?: string, // to be deleted
    contract?: Contract[],
    notification?: iDeviceNotification,
    licensePackageId?: string,
    deviceId?        : string,
    user_settings : DeviceSettings,
    license?: AccountLicensePackage
}

/*
export interface Device{
    PIN?: string,
    apk_signature?   : string | null,
    apk_version?     : string | null, 
    auto_signin?     : number,
    avgWeekUsage?    : number,
    channel?         : number,
    checkin_time?    : string | null,
    created_at?      : string | null,
    cyb_service_online?   : boolean,
    deleted_at?      : string | null,
    deviceID        : string,
    deviceName      : string,
    deviceUnique?    : string,    
    device_height?   : string,
    device_id?       : number,
    device_name?     : string,
    device_params?   : string,
    device_unique?   : string,
    device_width?    : number,
    disabled_keycodes?   : string,
    display_time?    : number,
    display_time_mode?   : number,
    display_time_position?   : number,    
    display_watermark?   : number,
    display_weather? : number,
    display_weather_position?    : number,
    enable_external? : number,
    groupId?         : string,
    group_id?        : number,
    id?              : string,    
    last_http_header?: string,
    last_status_change? : string | null
    mac_address?     : string,
    manufacturer?    : string,
    model?           : string,
    note?            : string | null,
    os_version?      : string | null,    
    padding_h?       : number,
    padding_v?       : number,
    portnum?         : number,
    remoteip?        : string,
    restart?         : number,
    rotation?        : number,
    settings?        : string | null,
    status          : string,
    status_id?       : number,
    subscription_plan_id?    : number,
    timezone?        : string,
    turn_device_off? : string | null,
    turn_device_on?  : string | null,
    type            : string,
    updated_at?      : string | null,
    user_id?         : number,
    watermark_position?  : number,
    weather_city_code?   : number | null    
}
*/

export interface PushNotification {
    deviceId: string,
    event: string,
    data?: any,
    subscriber: string,
}

export const availablePushEvent = {
    restartPlayer :'restartPlayer',
    restartService: 'restartService',
    screenshot : 'screenshot',
    deviceInfo : 'deviceInfo'
}
 
export interface Contract{
    created_at  : string | null,
    created_by  : string | null,
    deviceId    : string,
    end_date    : string | null,
    last_email_sent : string | null,
    num_email_sent  : number,
    start_date  : string | null,
    status_id   : number,
    terms       : string
}


// Data Pre-assignment
// ----------------------------------------------
export const EXPIREDWARNINGTHRESDHOLD = 30 // 30 days
export const OFFLINEPERIODTHRESHOLD   = 5  //refer to 5mn
// export const OFFLINEPERIODTHRESHOLD = 15 * 1440 //1440mn = 1days
export const rotationOptions: OptionProps[] = [    
    { value: '0',   label: '0 Degree'},
    { value: '-90', label: '-90 Degree (Anti-clockwise)'},    
    { value: '90',  label: '+90 Degree (Clockwise)'},
    { value: '180', label: '180 Degree'},
]
export const LICENCEPACKAGE_FOR_FREELICENSE = ["R5jMRl09Ew"] //freeLicense licPackageIds
export const LICENCEPACKAGE_FOR_SMB         = ["qgzOnk03aG"] //freeLicense licPackageIds
export const LICENCEPACKAGE_FOR_CORPORATE   = ["4K50vb0n9V"] //corporate licPackageIds
export const LICENCEPACKAGE_FOR_ENTERPRISE  = ["BJDMkm0Eya"] //enterprise licPackageIds
export const LICENCEPACKAGE_FOR_SB_PARTNER  = ["6q2MjY8PGx"] //sbPartner licPackageIds
export const LICENCEPACKAGE_FOR_SB_PARTNER_WATERMARK  = ["myv83QOrBZ"] //sbPartner Watermark licPackageIds
export const LICENCEPACKAGE_FOR_ADVERTISER  = ["YvyMYNO4wz"] //sbAdvertiser licPackageIds

export const LICENCEPACKAGE_FOR_ADVANCE_FEATURES = [
                                                        ...LICENCEPACKAGE_FOR_FREELICENSE,
                                                        ...LICENCEPACKAGE_FOR_CORPORATE,
                                                        ...LICENCEPACKAGE_FOR_ENTERPRISE,
                                                        ...LICENCEPACKAGE_FOR_SB_PARTNER,
                                                        ...LICENCEPACKAGE_FOR_SB_PARTNER_WATERMARK,
                                                        ...LICENCEPACKAGE_FOR_ADVERTISER
                                                    ] //corporate and entreprise licPackageIds

export const COUNTRYCODES = [ 
  {name: 'Afghanistan', code: 'AF'}, 
  {name: 'Åland Islands', code: 'AX'}, 
  {name: 'Albania', code: 'AL'}, 
  {name: 'Algeria', code: 'DZ'}, 
  {name: 'American Samoa', code: 'AS'}, 
  {name: 'AndorrA', code: 'AD'}, 
  {name: 'Angola', code: 'AO'}, 
  {name: 'Anguilla', code: 'AI'}, 
  {name: 'Antarctica', code: 'AQ'}, 
  {name: 'Antigua and Barbuda', code: 'AG'}, 
  {name: 'Argentina', code: 'AR'}, 
  {name: 'Armenia', code: 'AM'}, 
  {name: 'Aruba', code: 'AW'}, 
  {name: 'Australia', code: 'AU'}, 
  {name: 'Austria', code: 'AT'}, 
  {name: 'Azerbaijan', code: 'AZ'}, 
  {name: 'Bahamas', code: 'BS'}, 
  {name: 'Bahrain', code: 'BH'}, 
  {name: 'Bangladesh', code: 'BD'}, 
  {name: 'Barbados', code: 'BB'}, 
  {name: 'Belarus', code: 'BY'}, 
  {name: 'Belgium', code: 'BE'}, 
  {name: 'Belize', code: 'BZ'}, 
  {name: 'Benin', code: 'BJ'}, 
  {name: 'Bermuda', code: 'BM'}, 
  {name: 'Bhutan', code: 'BT'}, 
  {name: 'Bolivia', code: 'BO'}, 
  {name: 'Bosnia and Herzegovina', code: 'BA'}, 
  {name: 'Botswana', code: 'BW'}, 
  {name: 'Bouvet Island', code: 'BV'}, 
  {name: 'Brazil', code: 'BR'}, 
  {name: 'British Indian Ocean Territory', code: 'IO'}, 
  {name: 'Brunei Darussalam', code: 'BN'}, 
  {name: 'Bulgaria', code: 'BG'}, 
  {name: 'Burkina Faso', code: 'BF'}, 
  {name: 'Burundi', code: 'BI'}, 
  {name: 'Cambodia', code: 'KH'}, 
  {name: 'Cameroon', code: 'CM'}, 
  {name: 'Canada', code: 'CA'}, 
  {name: 'Cape Verde', code: 'CV'}, 
  {name: 'Cayman Islands', code: 'KY'}, 
  {name: 'Central African Republic', code: 'CF'}, 
  {name: 'Chad', code: 'TD'}, 
  {name: 'Chile', code: 'CL'}, 
  {name: 'China', code: 'CN'}, 
  {name: 'Christmas Island', code: 'CX'}, 
  {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
  {name: 'Colombia', code: 'CO'}, 
  {name: 'Comoros', code: 'KM'}, 
  {name: 'Congo', code: 'CG'}, 
  {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
  {name: 'Cook Islands', code: 'CK'}, 
  {name: 'Costa Rica', code: 'CR'}, 
  {name: 'Cote D\'Ivoire', code: 'CI'}, 
  {name: 'Croatia', code: 'HR'}, 
  {name: 'Cuba', code: 'CU'}, 
  {name: 'Cyprus', code: 'CY'}, 
  {name: 'Czech Republic', code: 'CZ'}, 
  {name: 'Denmark', code: 'DK'}, 
  {name: 'Djibouti', code: 'DJ'}, 
  {name: 'Dominica', code: 'DM'}, 
  {name: 'Dominican Republic', code: 'DO'}, 
  {name: 'Ecuador', code: 'EC'}, 
  {name: 'Egypt', code: 'EG'}, 
  {name: 'El Salvador', code: 'SV'}, 
  {name: 'Equatorial Guinea', code: 'GQ'}, 
  {name: 'Eritrea', code: 'ER'}, 
  {name: 'Estonia', code: 'EE'}, 
  {name: 'Ethiopia', code: 'ET'}, 
  {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
  {name: 'Faroe Islands', code: 'FO'}, 
  {name: 'Fiji', code: 'FJ'}, 
  {name: 'Finland', code: 'FI'}, 
  {name: 'France', code: 'FR'}, 
  {name: 'French Guiana', code: 'GF'}, 
  {name: 'French Polynesia', code: 'PF'}, 
  {name: 'French Southern Territories', code: 'TF'}, 
  {name: 'Gabon', code: 'GA'}, 
  {name: 'Gambia', code: 'GM'}, 
  {name: 'Georgia', code: 'GE'}, 
  {name: 'Germany', code: 'DE'}, 
  {name: 'Ghana', code: 'GH'}, 
  {name: 'Gibraltar', code: 'GI'}, 
  {name: 'Greece', code: 'GR'}, 
  {name: 'Greenland', code: 'GL'}, 
  {name: 'Grenada', code: 'GD'}, 
  {name: 'Guadeloupe', code: 'GP'}, 
  {name: 'Guam', code: 'GU'}, 
  {name: 'Guatemala', code: 'GT'}, 
  {name: 'Guernsey', code: 'GG'}, 
  {name: 'Guinea', code: 'GN'}, 
  {name: 'Guinea-Bissau', code: 'GW'}, 
  {name: 'Guyana', code: 'GY'}, 
  {name: 'Haiti', code: 'HT'}, 
  {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
  {name: 'Holy See (Vatican City State)', code: 'VA'}, 
  {name: 'Honduras', code: 'HN'}, 
  {name: 'Hong Kong', code: 'HK'}, 
  {name: 'Hungary', code: 'HU'}, 
  {name: 'Iceland', code: 'IS'}, 
  {name: 'India', code: 'IN'}, 
  {name: 'Indonesia', code: 'ID'}, 
  {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
  {name: 'Iraq', code: 'IQ'}, 
  {name: 'Ireland', code: 'IE'}, 
  {name: 'Isle of Man', code: 'IM'}, 
  {name: 'Israel', code: 'IL'}, 
  {name: 'Italy', code: 'IT'}, 
  {name: 'Jamaica', code: 'JM'}, 
  {name: 'Japan', code: 'JP'}, 
  {name: 'Jersey', code: 'JE'}, 
  {name: 'Jordan', code: 'JO'}, 
  {name: 'Kazakhstan', code: 'KZ'}, 
  {name: 'Kenya', code: 'KE'}, 
  {name: 'Kiribati', code: 'KI'}, 
  {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
  {name: 'Korea, Republic of', code: 'KR'}, 
  {name: 'Kuwait', code: 'KW'}, 
  {name: 'Kyrgyzstan', code: 'KG'}, 
  {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
  {name: 'Latvia', code: 'LV'}, 
  {name: 'Lebanon', code: 'LB'}, 
  {name: 'Lesotho', code: 'LS'}, 
  {name: 'Liberia', code: 'LR'}, 
  {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
  {name: 'Liechtenstein', code: 'LI'}, 
  {name: 'Lithuania', code: 'LT'}, 
  {name: 'Luxembourg', code: 'LU'}, 
  {name: 'Macao', code: 'MO'}, 
  {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
  {name: 'Madagascar', code: 'MG'}, 
  {name: 'Malawi', code: 'MW'}, 
  {name: 'Malaysia', code: 'MY'}, 
  {name: 'Maldives', code: 'MV'}, 
  {name: 'Mali', code: 'ML'}, 
  {name: 'Malta', code: 'MT'}, 
  {name: 'Marshall Islands', code: 'MH'}, 
  {name: 'Martinique', code: 'MQ'}, 
  {name: 'Mauritania', code: 'MR'}, 
  {name: 'Mauritius', code: 'MU'}, 
  {name: 'Mayotte', code: 'YT'}, 
  {name: 'Mexico', code: 'MX'}, 
  {name: 'Micronesia, Federated States of', code: 'FM'}, 
  {name: 'Moldova, Republic of', code: 'MD'}, 
  {name: 'Monaco', code: 'MC'}, 
  {name: 'Mongolia', code: 'MN'}, 
  {name: 'Montserrat', code: 'MS'}, 
  {name: 'Morocco', code: 'MA'}, 
  {name: 'Mozambique', code: 'MZ'}, 
  {name: 'Myanmar', code: 'MM'}, 
  {name: 'Namibia', code: 'NA'}, 
  {name: 'Nauru', code: 'NR'}, 
  {name: 'Nepal', code: 'NP'}, 
  {name: 'Netherlands', code: 'NL'}, 
  {name: 'Netherlands Antilles', code: 'AN'}, 
  {name: 'New Caledonia', code: 'NC'}, 
  {name: 'New Zealand', code: 'NZ'}, 
  {name: 'Nicaragua', code: 'NI'}, 
  {name: 'Niger', code: 'NE'}, 
  {name: 'Nigeria', code: 'NG'}, 
  {name: 'Niue', code: 'NU'}, 
  {name: 'Norfolk Island', code: 'NF'}, 
  {name: 'Northern Mariana Islands', code: 'MP'}, 
  {name: 'Norway', code: 'NO'}, 
  {name: 'Oman', code: 'OM'}, 
  {name: 'Pakistan', code: 'PK'}, 
  {name: 'Palau', code: 'PW'}, 
  {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
  {name: 'Panama', code: 'PA'}, 
  {name: 'Papua New Guinea', code: 'PG'}, 
  {name: 'Paraguay', code: 'PY'}, 
  {name: 'Peru', code: 'PE'}, 
  {name: 'Philippines', code: 'PH'}, 
  {name: 'Pitcairn', code: 'PN'}, 
  {name: 'Poland', code: 'PL'}, 
  {name: 'Portugal', code: 'PT'}, 
  {name: 'Puerto Rico', code: 'PR'}, 
  {name: 'Qatar', code: 'QA'}, 
  {name: 'Reunion', code: 'RE'}, 
  {name: 'Romania', code: 'RO'}, 
  {name: 'Russian Federation', code: 'RU'}, 
  {name: 'RWANDA', code: 'RW'}, 
  {name: 'Saint Helena', code: 'SH'}, 
  {name: 'Saint Kitts and Nevis', code: 'KN'}, 
  {name: 'Saint Lucia', code: 'LC'}, 
  {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
  {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
  {name: 'Samoa', code: 'WS'}, 
  {name: 'San Marino', code: 'SM'}, 
  {name: 'Sao Tome and Principe', code: 'ST'}, 
  {name: 'Saudi Arabia', code: 'SA'}, 
  {name: 'Senegal', code: 'SN'}, 
  {name: 'Serbia and Montenegro', code: 'CS'}, 
  {name: 'Seychelles', code: 'SC'}, 
  {name: 'Sierra Leone', code: 'SL'}, 
  {name: 'Singapore', code: 'SG'}, 
  {name: 'Slovakia', code: 'SK'}, 
  {name: 'Slovenia', code: 'SI'}, 
  {name: 'Solomon Islands', code: 'SB'}, 
  {name: 'Somalia', code: 'SO'}, 
  {name: 'South Africa', code: 'ZA'}, 
  {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
  {name: 'Spain', code: 'ES'}, 
  {name: 'Sri Lanka', code: 'LK'}, 
  {name: 'Sudan', code: 'SD'}, 
  {name: 'Suriname', code: 'SR'}, 
  {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
  {name: 'Swaziland', code: 'SZ'}, 
  {name: 'Sweden', code: 'SE'}, 
  {name: 'Switzerland', code: 'CH'}, 
  {name: 'Syrian Arab Republic', code: 'SY'}, 
  {name: 'Taiwan, Province of China', code: 'TW'}, 
  {name: 'Tajikistan', code: 'TJ'}, 
  {name: 'Tanzania, United Republic of', code: 'TZ'}, 
  {name: 'Thailand', code: 'TH'}, 
  {name: 'Timor-Leste', code: 'TL'}, 
  {name: 'Togo', code: 'TG'}, 
  {name: 'Tokelau', code: 'TK'}, 
  {name: 'Tonga', code: 'TO'}, 
  {name: 'Trinidad and Tobago', code: 'TT'}, 
  {name: 'Tunisia', code: 'TN'}, 
  {name: 'Turkey', code: 'TR'}, 
  {name: 'Turkmenistan', code: 'TM'}, 
  {name: 'Turks and Caicos Islands', code: 'TC'}, 
  {name: 'Tuvalu', code: 'TV'}, 
  {name: 'Uganda', code: 'UG'}, 
  {name: 'Ukraine', code: 'UA'}, 
  {name: 'United Arab Emirates', code: 'AE'}, 
  {name: 'United Kingdom', code: 'GB'}, 
  {name: 'United States', code: 'US'}, 
  {name: 'United States Minor Outlying Islands', code: 'UM'}, 
  {name: 'Uruguay', code: 'UY'}, 
  {name: 'Uzbekistan', code: 'UZ'}, 
  {name: 'Vanuatu', code: 'VU'}, 
  {name: 'Venezuela', code: 'VE'}, 
  {name: 'Viet Nam', code: 'VN'}, 
  {name: 'Virgin Islands, British', code: 'VG'}, 
  {name: 'Virgin Islands, U.S.', code: 'VI'}, 
  {name: 'Wallis and Futuna', code: 'WF'}, 
  {name: 'Western Sahara', code: 'EH'}, 
  {name: 'Yemen', code: 'YE'}, 
  {name: 'Zambia', code: 'ZM'}, 
  {name: 'Zimbabwe', code: 'ZW'} 
]

export const getCountryCode = (country: string = 'Australia')  => {
    let countryCode= 'AU';
    // ---------------------------
    const foundEle = COUNTRYCODES.filter(ct => {
        return (ct.name.toLowerCase().includes(country.toLowerCase()))
    })
    if (country && foundEle){
        countryCode = foundEle[0].code
    }
    return countryCode;
}
export const emptyDevice: Device = {
    id          : "",
    deviceName  : "",
    // rotation    : "",
    groupId     : "",
    isHostSite  : false,
    groupName   : "",
    groupDisplayType : "",
    category    : "",
    groupCreatedAt: null,
    groupUpdatedAt: null,
    user_settings: {
        rotation: "0",
        location: "",
        device_time_zone: "Australia/Melbourne"
    },
    checkin_time: "",
}


// List of functions
// ----------------------------------
export const isDeviceOnline = (checkInTime: string, liveStatus?: string) => {
    // console.log(checkInTime," duration(", moment().diff(moment(checkInTime), 'minutes'),") - isOnline: ",(moment().diff(moment(checkInTime), 'minutes') <= OFFLINEPERIODTHRESHOLD)?"true":"false")

    // console.log("checkInTime: ",checkInTime)
    // console.log("moment().diff(moment(checkInTime), 'minutes'): ", moment().diff(moment(checkInTime), 'minutes'))

    var isOnline = 0
    // ----------------------------------
    if (liveStatus){
        if (["online"].includes(liveStatus) ){
          isOnline = 1
        }else if (["screen-off"].includes(liveStatus) ){
            isOnline = 2
          }
    }else{
        isOnline = (moment().diff(moment(checkInTime, "DD-MMM-YYYY  HH:mm:ss"), 'minutes') <= OFFLINEPERIODTHRESHOLD) ? 1 : 0
    }

    return  isOnline
}


export const filterOnlineDevices = (allDevices: Device[] | undefined) => {

    if (allDevices && allDevices.length>0){        
        const result = allDevices.filter((dev)=> {
            const dateStr = moment(moment.utc(dev.checkin_time).toDate()).local().format("DD-MMM-YYYY HH:mm:ss")
            // console.log("moment: ",moment().format("DD-MMM-YYYY HH:mm:ss"))
            // console.log("dateStr: ",dateStr)
            // console.log("(dev.groupId !== ''): ",(dev.groupId !== ""))
            // console.log("dev.checkin_time? isDeviceOnline(dateStr) : false: ",dev.checkin_time? isDeviceOnline(dateStr) : false)
            return (dev.groupId !== "") && (dev.checkin_time? isDeviceOnline(dateStr) : false)
        })
        // console.log("result : ",result)

        return result
    }else{
        return []
    }    
}

export const filterOfflineDevices = (allDevices: Device[] | undefined) => {

    if (allDevices && allDevices.length>0){        
        const result = allDevices.filter((dev)=> {
            const dateStr = moment(moment.utc(dev.checkin_time).toDate()).local().format("DD-MMM-YYYY HH:mm:ss")
            return (!((dev.groupId !== "") && (dev.checkin_time? isDeviceOnline(dateStr) : false)))
        })
        return result
    }else{
        return []
    }    
}

export const filterScheduledDevices = (allSchedGrps: Group[] | undefined, selectedDevices?: Device[]) => {
    if (allSchedGrps){
        var arrDevices: Device[] = []

        allSchedGrps.filter((grp)=> {
            if (grp.devices){
                let filteredDevices = grp.devices
                if (selectedDevices){
                    const selectedDeviceIds = selectedDevices.map((dev)=> dev.id)
                    filteredDevices = grp.devices.filter((dev)=> selectedDeviceIds.includes(dev.id))
                }
                arrDevices = [...arrDevices, ...filteredDevices]    //merge two array
            }
        })
        return arrDevices        
    }else{
        return []
    }    
}